<template>
    <div>
        <Header title="对接方式">
            <template v-slot:content>
                <div style="display: flex">
                    <div style="flex:1">
                    </div>
                    <div>
                        <Button type="primary" @click="add">新增</Button>
                    </div>

                </div>
            </template>
        </Header>
        <div class="my-white-mod">
            <PageTable  :loading="table.loading" :size="table.limit" :columns="table.columns" :data="table.data" :current="table.current" :total="table.total"  @switchPage="changepage" >
            </PageTable>
        </div>


        <Modal
                v-model="show_success"
                :title="title"
                width="400"
        >
            <div class="modal-title">对接方式</div>
            <div style="display: flex;align-items: center;">
                <Cascader :data="dock_data" placeholder="请选择上级" change-on-select @on-change="changeCode" v-model="submit_form.show_name" style="flex:2" ></Cascader>
                <Icon style="margin-left:5px;cursor: pointer" size="18" @click="loadCascade" type="md-refresh" />
            </div>
            <Input  style="margin:10px 0" placeholder="请填对接方式"  v-model="submit_form.name" />
            <Input  placeholder="请输入金额"  v-model="submit_form.money" />
            
            <div slot="footer">
                <Button  type="primary"  @click="update">确定</Button >
            </div>
        </Modal>
        <Modal
                v-model="show_del"
                title="删除"
                width="400"
                @on-ok="delete_needs"
        >
            <div class="my-modal-del">
                <Icon type="ios-alert" />
                是否删除该成交类型
            </div>
        </Modal>
    </div>

</template>
<script>
    import {dock_type_list, dock_type_manager, dock_type_del, get_dock_cascade_list } from "@/api/system";
    import {Header, PageTable} from "@/components/mainLayout"
    export default {
        components:{
            Header,
            PageTable
        },
        data(){
            return{
                title:"新增",
                show_success:false,
                show_del:false,
                delete_id:0,
                dock_data: [],
                pid:0,
                submit_form:{
                    show_name:[],
                    name:"",
                    up_name:[],
                    up_codes:[],
                    pid:0,
                    money:0
                },
                table:{
                    current:1,
                    total:0,
                    limit:30,
                    loading:false,
                    columns: [
                        {
                            align:'center',
                            type: 'index'
                        },
                        {
                            title: '上级',
                            align:'center',
                            key: 'up_names'
                        },
                        {
                            title: '对接方式',
                            align:'center',
                            key: 'name'
                        },
                        {
                            title: '金额',
                            align:'center',
                            key: 'money'
                        },
                        {
                            title: '操作',
                            align:'center',
                            key: 'id',
                            render: (h, params) => {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small'
                                        },
                                        style:{color:'#3F8CFF'},
                                        on: {
                                            click: () => {
                                                this.edit(params)
                                            }
                                        }
                                    }, '编辑'),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small'
                                        },
                                        style:{color:'#ff0000'},
                                        on: {
                                            click: () => {
                                                this.del(params);
                                            }
                                        }
                                    }, '删除')
                                ]);

                            }

                        }
                    ],
                    data: []
                }

            }
        },
        mounted(){
            this.loadCascade()
            this.list()
        },
        methods:{
            loadCascade(){
                get_dock_cascade_list().then(res=>{
                    if(res.code == 200) {
                        this.dock_data = res.data
                        this.$Message.success(res.msg);
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            list(){
                this.table.loading = true;
                dock_type_list({limit:this.table.limit, page:this.table.current}).then(res=>{
                    this.table.loading = false;
                    if (res.code == 200) {
                        this.table.data = res.data
                        this.table.total = res.total
                    } else {
                        this.table.data = []
                        this.table.total = 0
                    }
                })
            },
            changeCode(v,e){
                this.submit_form.pid = v.length == 0 ? 0 : v[v.length - 1]
                let names = [], codes = []
                for (var i in e) {
                    names.push(e[i].label);
                    codes.push(e[i].value)
                }
                this.submit_form.up_names = names.join(",")
                this.submit_form.up_codes = codes.join(",")
            },
            update(){
                if (this.submit_form.id == this.submit_form.pid) {
                    this.$Message.error("不能选择自己为上级");return;
                }
                if (this.submit_form.name == "" ){
                    this.$Message.error("对接方式不能为空");return;
                }
                dock_type_manager(this.submit_form).then(res=>{
                    if (res.code == 200) {
                        this.list();
                        this.loadCascade()
                        this.show_success = false
                        this.$Message.success(res.msg);
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            delete_needs(){
                dock_type_del({id:this.delete_id}).then(res=>{
                    if (res.code == 200) {
                        this.list();
                        this.$Message.success(res.msg);
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
            },
            add(){
                this.title = "新增";
                this.show_success = true;
                this.submit_form = {
                    show_name:[],
                    name : "",
                    money:0,
                    up_names:"",
                    up_codes:"",
                    pid:0
                };
            },
            edit(e){
                this.submit_form = e.row;
                this.submit_form.show_name = (this.submit_form.up_codes != "" && this.submit_form.up_codes != null) ? (this.submit_form.up_codes.split(",")).map(r=>{ return parseInt(r) }) : []
                console.log(this.submit_form)
                this.title = "编辑";
                this.show_success = true;
            },
            del(e){
                this.show_del = true;
                this.delete_id = e.row.id;
            },
            changepage(index){
                this.table.current = index;
                this.list();
            }
        }
    }
</script>
